// @ts-nocheck
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ContentZone from "@store/Library/Components/ContentZone";
import * as React from "react";

type Props = WidgetProps & HasProduct;

const ProductDetailsMoreInfo: React.FC<Props> = ({ product }) => {
    const title = translate("More Information");
    const content = product.properties.moreInformation;

    if (!content) {
        return null;
    }
    return <ContentZone title={title} content={content} contentCellWidth={12} />;
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsMoreInfo),
    definition: {
        displayName: "More Information",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
